import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/role/getters";
import { actions } from "@/store/modules/role/actions";
import { mutations } from "@/store/modules/role/mutations";
import { IRoleState, state } from "@/store/modules/role/state";

export const role: Module<IRoleState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
